import React from 'react';
import ReactDOM from 'react-dom/client';
import BonIntervention from './BonIntervention';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<BonIntervention />);
